import Info from "@mui/icons-material/Info";
import { Box, Chip, Grid, Stack, Typography } from "@mui/material";
import { FormSelect } from "components/Forms/FormSelect";
import { FormTextField } from "components/Forms/FormTextField";
import { Payee } from "generated-graphql/graphql";
import { Control } from "react-hook-form";
import { PayeeFormInputs } from "../lib/types";

interface PayeeSectionProps {
  control: Control<PayeeFormInputs>;
  isLob: boolean;
  notEditable: boolean;
}

export function PayeeSection({
  control,
  isLob,
  notEditable,
}: PayeeSectionProps) {
  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
        <Typography variant="h6">Payee</Typography>
        <Chip
          label="LEPC Info"
          variant="outlined"
          size="small"
          color="info"
          clickable
          onClick={() =>
            window.open(
              "https://docs.google.com/spreadsheets/d/1rh_889u-RRv7BHQN_suWX4zW6lshXigvB_J2PmzoiVw/edit#gid=857027531",
              "_blank"
            )
          }
          icon={<Info fontSize="small" />}
          sx={{
            height: "24px",
            "& .MuiChip-label": {
              fontSize: "0.75rem",
              fontWeight: 500,
            },
          }}
        />
      </Stack>
      <Grid container spacing={2}>
        <Grid size={6}>
          <FormSelect
            label="Payee Type"
            selectItems={[Payee.Lepc, Payee.Fd, Payee.Serc, Payee.Rcra].map(
              (val) => ({
                value: val,
                display: val,
              })
            )}
            name="payeeType"
            control={control}
          />
        </Grid>
        <Grid size={6}>
          <FormTextField
            name="recipientName"
            label="Recipient/Payee"
            maxLength={isLob ? 40 : undefined}
            control={control}
            disabled={notEditable}
          />
        </Grid>
        <Grid size={12}>
          <FormTextField
            name="companyName"
            label="Company (Optional)"
            maxLength={isLob ? 40 : undefined}
            control={control}
            disabled={notEditable}
          />
        </Grid>
        <Grid size={12}>
          <FormTextField
            name="addressLine1"
            label="Address Line 1"
            maxLength={isLob ? 64 : undefined}
            control={control}
            disabled={notEditable}
          />
        </Grid>
        <Grid size={12}>
          <FormTextField
            name="addressLine2"
            label="Address Line 2"
            maxLength={isLob ? 64 : undefined}
            control={control}
            disabled={notEditable}
          />
        </Grid>
        <Grid size={5}>
          <FormTextField
            name="city"
            label="City"
            maxLength={isLob ? 200 : undefined}
            control={control}
            disabled={notEditable}
          />
        </Grid>
        <Grid size={2}>
          <FormTextField
            name="state"
            label="State"
            control={control}
            disabled={notEditable}
          />
        </Grid>
        <Grid size={5}>
          <FormTextField
            name="zip"
            label="Zip"
            control={control}
            disabled={notEditable}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
